/* tslint:disable */
/* eslint-disable */

import React, { FunctionComponent } from 'react';
import { ViewProps } from 'react-native';
import { Svg, GProps, Path } from 'react-native-svg';
import { getIconColor } from './helper';

interface Props extends GProps, ViewProps {
  size?: number;
  color?: string | string[];
}

let PointGift: FunctionComponent<Props> = ({ size, color, ...rest }) => {
  return (
    <Svg viewBox="0 0 1024 1024" width={size} height={size} {...rest}>
      <Path
        d="M645.972992 252.126208c-15.41632 15.41632-29.80864 24.576-42.665984 31.060992h-39.140352c1.47968-14.164992 12.23168-42.04032 41.529344-71.337984 38.969344-38.912 75.435008-45.340672 80.497664-40.220672 5.006336 5.006336-1.308672 41.52832-40.220672 80.49664zM420.75136 283.1872c-12.857344-6.484992-27.249664-15.644672-42.609664-31.004672-38.969344-39.02464-45.227008-75.491328-40.220672-80.49664 0.966656-0.96768 3.014656-1.47968 5.916672-1.47968 12.91264 0 42.894336 10.068992 74.580992 41.699328 29.184 29.241344 39.993344 57.059328 41.472 71.281664H420.75136z m62.833664 227.550208v398.222336h-256c-31.14496 0-56.379392-24.92416-56.881152-55.947264l-0.008192-0.94208V510.737408H483.584z m369.777664 0V852.0704c0 31.459328-25.428992 56.889344-56.88832 56.889344h-256v-398.22336H853.36064zM458.63936 171.68384c27.590656 27.59168 45.681664 57.969664 53.419008 85.90336 7.68-27.933696 25.769984-58.31168 53.417984-85.95968 57.344-57.401344 126.691328-74.582016 160.939008-40.220672 32.21504 32.32768 18.486272 95.09888-30.532608 150.114304l-1.49504 1.665024h159.003648c31.08864 0 56.378368 24.92416 56.881152 55.947264l0.007168 0.94208v56.88832c0 31.14496-24.978432 56.380416-55.948288 56.881152l-0.940032 0.008192H540.500992V283.1872h-56.88832v170.667008H170.667008c-31.08864 0-56.379392-24.92416-56.881152-55.947264l-0.008192-0.94208v-56.88832c0-31.14496 24.979456-56.380416 55.948288-56.881152l0.941056-0.008192h159.003648c-50.28864-55.465984-64.56832-119.124992-31.971328-151.721984 34.304-34.532352 103.595008-17.124352 160.939008 40.219648z"
        fill={getIconColor(color, 0, '#333333')}
      />
    </Svg>
  );
};

PointGift.defaultProps = {
  size: 18,
};

PointGift = React.memo ? React.memo(PointGift) : PointGift;

export default PointGift;
